export const LocalesProductEnum = Object.freeze({
  Czech: 'produkt',
  German: 'produkt',
  French: 'produit',
  Slovak: 'produkt',
  Spanish: 'producto',
})

export const LocalesProductsEnum = Object.freeze({
  French: 'produits',
  German: 'produkte',
  Czech: 'produkty',
  Slovak: 'produkty',
  Spanish: 'productos',
})
